module.exports = __webpack_public_path__ + "img/logo.ce4976ef.png";